import { createVendorFaQ, deleteVendorFaQ, getAllVendorFaQ, getVendorFaQForUser, updateVendorFaQ } from './asyncThunks';

export const getAllVendorFaQBuilder = builder => {
  builder.addCase(getAllVendorFaQ.pending, state => {
    state.getAllVendorFaQPending = true;
  });
  builder.addCase(getAllVendorFaQ.fulfilled, (state, { payload }) => {
    const { data, maxReached, total, perPage } = payload;
    state.allFAQ.data = data;
    state.allFAQ.maxReached = maxReached;
    state.allFAQ.total = total;
    state.allFAQ.perPage = perPage;
    state.getAllVendorFaQPending = false;
  });
  builder.addCase(getAllVendorFaQ.rejected, state => {
    state.getAllVendorFaQPending = false;
  });
};

export const getVendorFaQForUserBuilder = builder => {
  builder.addCase(getVendorFaQForUser.pending, state => {
    state.getVendorFaQForUserPending = true;
  });
  builder.addCase(getVendorFaQForUser.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.selectedFAQ = data;

    state.getVendorFaQForUserPending = false;
  });
  builder.addCase(getVendorFaQForUser.rejected, state => {
    state.getVendorFaQForUserPending = false;
  });
};

export const createVendorFaQBuilder = builder => {
  builder.addCase(createVendorFaQ.pending, state => {
    state.createVendorFaQPending = true;
  });
  builder.addCase(createVendorFaQ.fulfilled, (state, { payload }) => {
    const { data } = payload;
    state.allFAQ.data = [...state.allFAQ.data, data];

    state.createVendorFaQPending = false;
  });
  builder.addCase(createVendorFaQ.rejected, state => {
    state.createVendorFaQPending = false;
  });
};

export const deleteVendorFaQBuilder = builder => {
  builder.addCase(deleteVendorFaQ.pending, state => {
    state.deleteVendorFaQPending = true;
  });
  builder.addCase(deleteVendorFaQ.fulfilled, (state, { payload }) => {
    const { id } = payload.data;
    state.allFAQ.data = state.allFAQ.data.filter(faq => faq.id !== id);

    state.deleteVendorFaQPending = false;
  });
  builder.addCase(deleteVendorFaQ.rejected, state => {
    state.deleteVendorFaQPending = false;
  });
};

export const updateVendorFaQBuilder = builder => {
  builder.addCase(updateVendorFaQ.pending, state => {
    state.updateVendorFaQPending = true;
  });
  builder.addCase(updateVendorFaQ.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.allFAQ.data = state.allFAQ.data.map(faq => {
      if (faq.id === data.id) {
        faq.question = data.question;
        faq.answer = data.answer;
      }
      return faq;
    });

    state.updateVendorFaQPending = false;
  });
  builder.addCase(updateVendorFaQ.rejected, state => {
    state.updateVendorFaQPending = false;
  });
};
